import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Thunk pour récupérer les avis d’un établissement
export const fetchReviews = createAsyncThunk(
  "avis/fetchReviews",
  async ({ idEtablissement, page = 1 }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return rejectWithValue({ message: "Token manquant" });

      const apiUrl = `${process.env.REACT_APP_API_URL}reviews/etablissement/${idEtablissement}?page=${page}`;
      const response = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log("response.data:", response.data);
      return response?.data?.reviews;
    } catch (error) {
      // console.error("Erreur API fetchReviews :", error);
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
//Thunk pour répondre à un avis
export const respondToReview = createAsyncThunk(
  "reviews/respond",
  async ({ reviewId, responseText }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const apiUrl = `${process.env.REACT_APP_API_URL}reviews/${reviewId}/respond`;
      const response = await axios.post(
        apiUrl,
        { response: responseText },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      // console.error("Respond API Error:", error);
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
//fetch review pros prestataire-reviews
export const fetchReviewsPro = createAsyncThunk(
  "avis/fetchReviewsPro",
  async (_, { rejectWithValue }) => {
    try {
      

      const apiUrl = `${process.env.REACT_APP_API_URL}prestataire-reviews`;
      const response = await axios.get(apiUrl);
      //  console.log("response.data:", response.data);
      return response?.data;
    } catch (error) {
      // console.error("Erreur API fetchReviews :", error);
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

const avisSlice = createSlice({
  name: "avis",
  initialState: {
    reviews: [],
    reviewsPro: [],
    pagination: {
      currentPage: 1,
      lastPage: 1,
      total: 0,
    },
    status: "idle",
    statusLandingPage: "idle",
    error: null,
    respondStatus: "idle",
    respondError: null,
  },
  reducers: {
    clearReviews: (state) => {
      state.reviews = [];
      state.pagination = { currentPage: 1, lastPage: 1, total: 0 };
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReviews.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchReviews.fulfilled, (state, action) => {
        state.status = "succeeded";

        // Extraire les données du payload
        const { data, current_page, last_page, total } = action.payload || {};

        // Mettre à jour les reviews

        state.reviews = Array.isArray(data) ? data : [];
        // console.log("Mettre à jour les reviews", state.reviews);

        // Mettre à jour la pagination
        state.pagination = {
          currentPage: current_page || 1,
          lastPage: last_page || 1,
          total: total || 0,
        };
      })

      .addCase(fetchReviews.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || { message: "Erreur inconnue" };
      })
      //Répondre à un avis
      .addCase(respondToReview.pending, (state) => {
        state.respondStatus = "loading";
        state.respondError = null;
      })
      .addCase(respondToReview.fulfilled, (state, action) => {
        state.respondStatus = "succeeded";
      })
      .addCase(respondToReview.rejected, (state, action) => {
        state.respondStatus = "failed";
        state.respondError =
          action.payload || "Erreur inconnue lors de la réponse";
      })
      // reviews pro
      .addCase(fetchReviewsPro.pending, (state) => {
         state.statusLandingPage = "loading";
        state.error = null;
      })
      .addCase(fetchReviewsPro.fulfilled, (state, action) => {
         state.statusLandingPage = "succeeded";
        state.reviewsPro = action.payload; // Ensure action.payload contains the array of reviews
      })
  },
});

// Sélecteurs
export const selectReviews = (state) => state.avisClient.reviews;
export const selectPagination = (state) => state.avisClient.pagination;
export const selectRespondStatus = (state) => state.reviews.respondStatus;
export const selectRespondError = (state) => state.reviews.respondError;
// Actions
export const { clearReviews } = avisSlice.actions;

// Reducer
export default avisSlice.reducer;
